import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { TSitecoreJssFormProps } from './types/SitecoreJssForm.type';
import defaultFieldFactory from './fieldFactory';
import FieldValidationError from './components/fieldValidationError';
import fieldWrapper from './components/fieldWrapper';
import { sitecoreApiHost, sitecoreApiKey } from '../../temp/config';
import { isInternalUrl } from '../../utils/linkUtils';
import './styles.scss';

import JssForm from '../SitecoreJssForm/components/JssForm/JssForm';
import LazySection from '../../react-only-components/LazySection';
import Spinner from '../../react-only-components/Spinner/Spinner';
import withRouter from '../@shared/withRouter';

const SitecoreJssForm: FC<TSitecoreJssFormProps> = ({
  fields,
  navigate,
  isContact = false,
}) => {
  const loader = useSelector((state: any) => {
    return state.loader
  })

  return (
    <LazySection>
      {loader && <Spinner />}
      <section
        className={`sitecore-jss-form-parent ${
          isContact ? 'sitecore-jss-form-parent--contact' : ''
        }`}
        id={fields?.formItemId?.id}
      >
        <section
          className={`sitecore-jss-form ${
            isContact ? 'sitecore-jss-form--contact' : ''
          }`}
        >
          <JssForm
            form={fields}
            sitecoreApiHost={sitecoreApiHost}
            sitecoreApiKey={sitecoreApiKey}
            fieldFactory={defaultFieldFactory}
            errorComponent={() => <></>}
            fieldValidationErrorsComponent={FieldValidationError as any}
            fieldWrapperComponent={fieldWrapper}
            onRedirect={(url) => {
              if (isInternalUrl(url)) {
                navigate(url)
              } else {
                window.location.href = url
              }
            }}
          />
        </section>
      </section>
    </LazySection>
  )
}

export default withRouter(SitecoreJssForm)
